import { Component, Input } from '@angular/core';

/**
 * BaseExpansionPanelComponent provides an expandable details-summary view
 *
 *
 * @example
 * <base-expansion-panel
 *    [title]="'industry_surcharges.title'"
 *     *ngIf="assignment.industrySurcharges"
 *  >
 *    <base-industry-surcharges [surcharges]="assignment.industrySurcharges"></base-industry-surcharges>
 * </base-expansion-panel>
 */

@Component({
  selector: 'base-expansion-panel',
  templateUrl: './base-expansion-panel.component.html',
})
export class BaseExpansionPanelComponent {
  @Input() title = '';
  @Input() titleClass = 'headline-20';
  @Input() contentExpandClass = 'mb-3';

  isOpen = false;

  togglePanel() {
    this.isOpen = !this.isOpen;
  }
}
